/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'app/gamma/src/types';

import { IconName } from 'app/common/components/controls';
import { toggleBoardStar } from 'app/gamma/src/modules/state/models/board-stars';
import { State } from 'app/gamma/src/modules/types';

import { isBoardStarred } from 'app/gamma/src/selectors/boards';

import styles from './StarredBoardButton.less';
import { BoardButton } from './BoardButton';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('board_list_item');

interface OwnProps {
  readonly idBoard: string;
}

interface StateProps {
  readonly isStarred: boolean;
}

interface DispatchProps {
  onClick(): void;
}

interface AllProps extends OwnProps, StateProps, DispatchProps {}

class StarredBoardButtonUnconnected extends React.Component<AllProps> {
  onClickHandler: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  };

  render() {
    const { isStarred } = this.props;

    return (
      <BoardButton
        className={isStarred ? styles.yellowStar : ''}
        icon={IconName.Star}
        onClick={this.onClickHandler}
        tabIndex={-1}
        title={format(
          'click-to-star-this-board-it-will-show-up-at-top-of-your-boards-list',
        )}
      />
    );
  }
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
  const { idBoard } = ownProps;

  return {
    isStarred: isBoardStarred(state, idBoard),
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: OwnProps,
): DispatchProps => {
  const { idBoard } = ownProps;

  return {
    onClick() {
      /**
       * MS Edge has an issue with racing conditions in React, or
       * with the way async/await works, or both.
       * With optimistic updates happening here, it seems
       * that React is too fast to unbind callbacks, and Edge lets
       * the click go through a then unbound <a> on RouterLink.
       *
       * A setTimeout here fixes the problem.
       *
       * TODO: Remove this when EdgeHTML is not supported anymore
       */
      setTimeout(() => {
        dispatch(toggleBoardStar({ idBoard }));
      });
    },
  };
};

export const StarredBoardButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StarredBoardButtonUnconnected);
